import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSupabase } from '../../supabaseAuth';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useSupabase();
  
  // Show loading spinner while authentication state is being determined
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted">Loading...</p>
        </div>
      </div>
    );
  }
  
  // Only redirect to login if we're definitely not authenticated and not loading
  if (!loading && !isAuthenticated && !user) {
    return <Navigate to="/login" replace />;
  }
  
  return children ? children : <Outlet />;
};

export default ProtectedRoute;
